<template>
	<div class="device">
		<div class="deviceMain">
			<div class="top">
				<div class="deviceWarp" v-for="(item, index) in deviceData">
					<div class="title">{{item.title}}</div>
					<div class="subtitle">{{item.memo}}</div>
					<ul class="deviceList">
						<li @click="toContent(val)" v-for="(val, key) in item.data"><span>{{val.title}}</span></li>
					</ul>
				</div>
			</div>
			<ercode></ercode>
		</div>
			
		<!--<div class="mask"></div>-->
	</div>
</template>

<script>
	import { get, isPC } from 'assets/api/config'
	import ercode from 'components/ercode'
	var img = {};
	
	export default {
		data() {
		    return {
		    	images:img,
		    	deviceData:'',
		    }
		},
	 	mounted() {
	 		this.init()
		},
	  	methods: {
	  		init(){
				let that = this;
				//游戏详情
				let requestParams = {
					act: 'webInstructionList',
					token: this.$route.params.id + '||' + this.$route.params.keyId,
			    }
				
				get(requestParams).then(function(res) {
					that.deviceData = res.data;
//		 			console.log(that.deviceData)
				});
			},
	  		toContent(obj){
	  			if(obj.type == 1){
	  				//目录
	  				this.$router.push({name:'device',params:{id:this.$route.params.id,keyId:obj.id}})
	  			}else if(obj.type == 2){
	  				//外链
	  				window.location.href = obj.PClinkUrl;
	  			}else{
	  				//正文
	  				this.$router.push({name:'faqContent',params:{id:obj.id}})
	  			}
//	  			
	  		}
	  	},
	  	watch:{
		  $route(to,from){
		  	this.init();
		  }
		},
		components: {
		    ercode
	 	},
	}
</script>

<style lang="less" scoped>
	.comShadow{
	    box-shadow: 0 4PX 15PX rgba(0, 0, 0, 0.1)
	}
	
	.device{
		min-height: 100vh;
		background-color: #f7f7f7;
		
		.deviceMain{
			position: relative;
			padding: 0 30PX;
			margin: 0 auto;
			max-width: 608PX;
			height: 100vh;
			background-color: #fff;
			
			.top{
				padding-top: 56PX;
			} 
		}
		
		position: relative;
		height: 100vh;
		
		.seat{
			width: 100%;
			height: 100PX;
		}
		
		.mask{
			position: fixed;
			bottom: 0;
			left: 0;
			height: 50PX;
			width: 100%;
			background-color: #f1f1f1;
		}
		
		.deviceWarp{
			margin-bottom:56PX;
			
			.title{
				margin-bottom: 16PX;
				color: #333;
				font-size: 24PX;
				font-weight: bold;
				text-align: left;
			}
			
			.subtitle{
				margin-bottom: 16PX;
				font-size: 16PX;
				color: #999;
				text-align: left;
			}
			
			.deviceList{
				li{
					.comShadow;
					
					margin-bottom: 10PX;
					padding: 0 20PX;
					height: 64PX;
					line-height: 64PX;
					border-radius: 10PX;
					font-size: 20PX;
					color: #333;
					text-align: left;
					
					span{
						display: block;
						width: 100%;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/faqPC/device.vue